export default __webpack_public_path__ + "static/media/whatsapp.63c4e8c0.webp";